
import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils'; 
import {postRequest } from '../../config/AxiosConfig';

const apiBaseUrl = API_URLS.CUSTOMER;

const getAuthHeaders = () => {
  const token = getToken();
  
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const EquifaxScoreV2Service = async (params,page = 1) => {
  try {
    const service = params.select_service;
    const response = await postRequest({
      url: apiBaseUrl + "credit-report/v2/" + service + "?page=" + page,
      headers: getAuthHeaders(),
      data: params
    });
    return response;
  } catch (error) {
    console.error('Error Fetch Equifax Score V2 Data :', error.response?.data || error.message);
    throw error;
  }
};



// At the top of your file
const API_BASE_URL = "https://javabackend.idspay.in/api/v1/";

export const downloadCreditReport = async (reference, type) => {
  try {
    const response = await postRequest({
      url: `${API_BASE_URL}download-credit-report`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        reference,
        type
      }
    });

    return {
      success: true,
      data: response?.data || response,
      message: response?.message || 'Report fetched successfully'
    };
  } catch (error) {
    console.error('Error downloading credit report:', error);
    return {
      success: false,
      error: error?.response?.data?.message || error?.message || 'Failed to fetch report',
      data: null
    };
  }
};


